export const SENSAI_EMBED_MODE = "td-sensai";
export const SENSAI_EMBED_SOURCE = "td";
export const SENSAI_MESSAGE_SOURCE = "csd";
export const SENSAI_MESSAGE_TARGET = "td-sensai";

export const SENSAI_EMBEDDED_WORKFLOW_ALLOWLIST = [
  "reset-task",
  "add-child",
  "remove-child",
  "create-class",
  "remove-class",
  "request-access",
  "request-access-other-teacher",
  "swap-students-results",
  "fix-duplicate-child",
  "fix-duplicate-results",
  "move-transfer-children",
  "update-teacher-roles",
  "remove-colleague-access",
  "remove-teacher-from-school",
  "invite-teacher-to-platform",
  "send-account-setup-link",
  "send-password-reset-link",
  "update-user-email",
  "rename-class",
  "assign-alpaca-lead",
  "assign-screener",
  "extend-trial",
  "restore-child-results",
  "send-whatsapp-group-invite",
  "provide-login-bypass",
  "activate-teacher-account",
  "merge-classes",
  "remove-teacher-assignment",
  "request-early-platform-access",
  "request-invoice",
  "trial-access-status",
  "fix-duplicate-child-results",
  "export-assessment-data",
  "make-results-visible",
  "escalate-technical-issue",
  "resolve-login-issue",
  "rename-user",
  "offer-to-add-teacher",
  "offer-meeting",
  "screening-guidance-resources",
  "escalate-feature-request"
];

const DEFAULT_TD_ALLOWED_ORIGINS = [
  "http://localhost:3000",
  "http://localhost:3002",
  "https://teacher.alpaca-assessment.com",
  "https://staging.teacher.alpaca-assessment.com",
  "https://test.teacher.alpaca-assessment.com"
];

const splitConfiguredOrigins = (value) =>
  String(value || "")
    .split(",")
    .map((origin) => origin.trim())
    .filter(Boolean);

export const normaliseOrigin = (value) => {
  const candidate = String(value || "").trim().replace(/^['"]|['"]$/g, "");

  if (!candidate) {
    return "";
  }

  try {
    return new URL(candidate).origin;
  } catch (error) {
    return "";
  }
};

export const getAllowedTeacherDashboardOrigins = () => {
  const configuredOrigins = [
    ...splitConfiguredOrigins(process.env.REACT_APP_TD_ALLOWED_ORIGINS),
    process.env.REACT_APP_TD_URL,
    process.env.REACT_APP_TD_ADMIN_DASHBOARD
  ];

  return Array.from(
    new Set(
      [...DEFAULT_TD_ALLOWED_ORIGINS, ...configuredOrigins]
        .map(normaliseOrigin)
        .filter(Boolean)
    )
  );
};

export const resolveAllowedParentOrigin = (...candidates) => {
  const allowedOrigins = new Set(getAllowedTeacherDashboardOrigins());

  return candidates
    .map(normaliseOrigin)
    .find((origin) => origin && allowedOrigins.has(origin)) || "";
};

export const buildSensaiWorkflowMessage = ({
  type,
  workflow,
  launchId,
  status = "",
  reference = "",
  message = ""
}) => ({
  source: SENSAI_MESSAGE_SOURCE,
  target: SENSAI_MESSAGE_TARGET,
  type,
  workflow,
  launchId,
  status,
  reference,
  message
});

export const postSensaiWorkflowMessage = ({
  parentWindow,
  targetOrigin,
  type,
  workflow,
  launchId,
  status,
  reference,
  message
}) => {
  if (!parentWindow || !targetOrigin || !type || !workflow || !launchId) {
    return false;
  }

  parentWindow.postMessage(
    buildSensaiWorkflowMessage({
      type,
      workflow,
      launchId,
      status,
      reference,
      message
    }),
    targetOrigin
  );

  return true;
};
